import { createAction } from 'redux-actions';

export const setTrialBalanceSnapshotViewLoaded = createAction(
  'SET_TRIAL_BALANCE_SNAPSHOT_VIEW_LOADED',
);

export const setSnapshotReadOnly = createAction('SET_SNAPSHOT_READ_ONLY');
